const contact = {
  logo: '/images/logo/logo.png',
  name: 'Hội cựu sinh viên Kinh tế K21 - Đại học Cần Thơ',

  networks: [
    {
      name: 'Zalo',
      className: 'zalo',
      icon: '/images/icons/zalo-logo.png',
      iconWhite: '/images/icons/zalo.png',
    },
    {
      name: 'Facebook',
      className: 'facebook',
      icon: '/images/icons/facebook-new.png',
      iconWhite: '/images/icons/facebook.png',
    },
    {
      name: 'Messenger',
      className: 'messenger',
      icon: '/images/icons/messenger.png',
      iconWhite: '',
    },
    {
      name: 'Tiktok',
      className: 'tiktok',
      icon: '/images/icons/tiktok-new.png',
      iconWhite: '/images/icons/tiktok.png',
    },
    {
      name: 'Youtube',
      className: 'youtube',
      icon: '',
      iconWhite: '/images/icons/youtube.png',
    },
  ],
  // youtube: 'https://www.youtube.com/embed/nzAUlUDs4FE?si=ZrppzCj3qfD8pWfP',
};

export default contact;
